import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";

import { Tooltip, Button } from "@mantine/core";

import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const { REACT_APP_ECLIPSE_API, REACT_APP_ECLIPSE_API_LOCAL } = process.env;

const COMP_DailyUsage_ByZone = ({
  _date_selected,
  // _date_selected_ori,
  _day_selected,
  _cafe,
  _pc,
  _total_pc,
  _zone,
  _showMoreInfo,
}) => {
  // console.log("xxxxx _date_selected", _date_selected);
  // console.log("xxxxx _cafe", _cafe);
  // console.log("xxxxx _pc", _pc);

  const darkGreenShades = [
    "rgba(0, 100, 0, 0.00)", // 0h (fully transparent)
    "rgba(0, 100, 0, 0.04)",
    "rgba(0, 100, 0, 0.08)",
    "rgba(0, 100, 0, 0.12)",
    "rgba(0, 100, 0, 0.16)",
    "rgba(0, 100, 0, 0.20)",
    "rgba(0, 100, 0, 0.24)",
    "rgba(0, 100, 0, 0.28)",
    "rgba(0, 100, 0, 0.32)",
    "rgba(0, 100, 0, 0.36)",
    "rgba(0, 100, 0, 0.40)",
    "rgba(0, 100, 0, 0.44)",
    "rgba(0, 100, 0, 0.48)",
    "rgba(0, 100, 0, 0.52)",
    "rgba(0, 100, 0, 0.56)",
    "rgba(0, 100, 0, 0.60)",
    "rgba(0, 100, 0, 0.64)",
    "rgba(0, 100, 0, 0.68)",
    "rgba(0, 100, 0, 0.72)",
    "rgba(0, 100, 0, 0.76)",
    "rgba(0, 100, 0, 0.80)",
    "rgba(0, 100, 0, 0.84)",
    "rgba(0, 100, 0, 0.88)",
    "rgba(0, 100, 0, 0.92)", // 23h (almost opaque)
  ];

  const FormatTime = ({ secInput, label = "" }) => {
    const h = Math.floor(secInput / 3600);
    const m = Math.floor((secInput % 3600) / 60);
    const s = secInput % 60;

    // Pad with leading zeros if needed
    const pad = (n) => String(n).padStart(2, "0");

    // Calculate usage percentage
    const percent = (total_Usage_Sec / (_total_pc * 24 * 60 * 60)) * 100 || 0;
    // Map percent (0-100) to index (0-23)
    const shadeIdx = Math.min(23, Math.floor((percent / 100) * 23));
    const bgColor = darkGreenShades[shadeIdx];

    // Extract alpha from rgba string
    const alpha = parseFloat(bgColor.split(",")[3]);
    // If alpha > 0.5, use white text, else black
    const textColor = alpha > 0.7 ? "white" : "black";

    return (
      <div
        style={{
          marginLeft: "0.1rem",
          marginBottom: "0.1rem",
          backgroundColor: loading ? "transparent" : "white",
          color: loading ? "transparent" : "black",
          width: "30px",
        }}
      >
        {_showMoreInfo ? (
          <>
            <div
              style={{
                fontSize: 10,
                padding: "0.2rem",
              }}
            >
              {`${_total_pc}pc`}
            </div>
            <div
              style={{
                fontSize: 10,
                padding: "0.2rem",
              }}
            >
              {` ${total_Usage_Sec}sec`}
            </div>
            <div
              style={{
                fontSize: 10,
                padding: "0.2rem",
              }}
            >
              {`🧮 ${total_Usage_Sec}sec / (${_total_pc}pc * 24h * 60m * 60s)`}
            </div>
          </>
        ) : null}
        <div
          style={{
            fontSize: 10,
            padding: "0.2rem",
            backgroundColor: loading ? "" : bgColor,
            color: loading ? "transparent" : textColor,
          }}
        >
          {percent?.toFixed(1)}
        </div>
      </div>
    );
  };

  const [loading, setLoading] = useState(false);

  const [total_Usage_Sec, setTotal_Usage_Sec] = useState(0);
  // const [DB_CafePC_ByCafe, setDB_CafePC_ByCafe] = useState([]);
  const get_DB_CafePC_ByDateCafeZone = async () => {
    setLoading(true);

    await axios
      //REACT_APP_ECLIPSE_API
      .post(
        `${REACT_APP_ECLIPSE_API}/get_awesome_pos__pcdata_daily_in_a_month__bydate_cafe_zone`,
        {
          date_selected: _date_selected,
          cafe: _cafe,
          zone: _zone,
        }
      )
      .then((res) => {
        console.log("get_DB_CafePC_ByDateCafeZone", res?.data);
        setTotal_Usage_Sec(res?.data?.[0]?.total_usage_sec);
        // setDB_CafePC_ByCafe(res?.data);
        setLoading(false);
      });
  };

  useEffect(() => {
    get_DB_CafePC_ByDateCafeZone();
  }, [_date_selected, _cafe, _pc]);

  return (
    <>
      <FormatTime secInput={total_Usage_Sec} label={_day_selected} />
    </>
  );
};

const Chart_Bar_CafePOS_HeatMap_Daily_ByZone = ({
  dateSelected,
  cafeSelected,
  pcSelected,
  pczoneSelected,
  total_pc,
  zone,
  showMoreInfo,
}) => {
  // // Filter ranges that belong to the selected date
  // const filteredRanges = DB_CafePC_ByCafe?.filter(
  //   (range) =>
  //     dayjs(range.dlsj).format("YYYY-MM-DD") === dateSelected ||
  //     dayjs(range.jssj).format("YYYY-MM-DD") === dateSelected
  // );

  // // Convert ranges into dayjs
  // const parsedRanges = filteredRanges?.map((range) => ({
  //   start: dayjs(range.dlsj),
  //   end: dayjs(range.jssj),
  // }));

  // // Generate time blocks every 15 minutes
  // const timeBlocks = [];
  // const startTime = dayjs(`${dateSelected} 00:00`);
  // for (let i = 0; i < 96; i++) {
  //   const time = startTime.add(i * 15, "minute");
  //   timeBlocks.push(time);
  // }

  // // Check if a time block falls within any of the ranges
  // const isInRange = (blockTime) => {
  //   return parsedRanges.some(({ start, end }) => {
  //     return blockTime.isSameOrAfter(start) && blockTime.isSameOrBefore(end);
  //   });
  // };

  //------------------------------------- func

  function getDaysInMonth(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.getMonth(); // 0-indexed

    // Get the number of days in the month
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    // Create array of days ['1', '2', ..., '31']
    const daysArray = Array.from({ length: daysInMonth }, (_, i) =>
      (i + 1).toString()
    );

    return daysArray;
  }

  function stringToColor(str) {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) + hash + str.charCodeAt(i); // djb2 hash
    }
    let color = "#";
    for (let i = 0; i < 3; i++) {
      // Force the value to be in the lower half (darker) of the color spectrum
      const value = Math.abs((hash >> (i * 8)) & 0xff) >> 1; // divide by 2 to keep it dark
      color += value.toString(16).padStart(2, "0");
    }
    return color;
  }

  // Helper to get duration in ?day ?hour ?min ?sec format
  function getDurationDHMS(start, end) {
    const totalSeconds = dayjs(end).diff(dayjs(start), "second");
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }

  // Update ExampleSessionList to use the new format
  function ExampleSessionList({ data }) {
    // Calculate total usage in seconds
    const totalSeconds = data.reduce(
      (sum, item) => sum + dayjs(item.jssj).diff(dayjs(item.dlsj), "second"),
      0
    );
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const totalUsageStr = `${days}d ${hours}h ${minutes}m ${seconds}s`;

    return (
      <div>
        <h3>Session List</h3>
        <table border="1" cellPadding={4} style={{ fontSize: 12 }}>
          <thead>
            <tr>
              <th>#</th>
              <th>Start (dlsj)</th>
              <th>End (jssj)</th>
              <th>Duration</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{item.dlsj}</td>
                <td>{item.jssj}</td>
                <td>{getDurationDHMS(item.dlsj, item.jssj)}</td>
              </tr>
            ))}
            {/* Summary row */}
            <tr>
              <td
                colSpan={3}
                style={{ fontWeight: "bold", textAlign: "right" }}
              >
                Total Usage
              </td>
              <td style={{ fontWeight: "bold" }}>{totalUsageStr}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  useEffect(() => {
    // console.log("CafePOST DB_CafePC_ByCafe:", DB_CafePC_ByCafe);
    // console.log("CafePOST dateSelected:", dateSelected);
  }, []);

  // useEffect(() => {
  //   get_DB_CafePC_ByDateCafePC(dateSelected, cafeSelected, pcSelected);
  // }, [dateSelected, cafeSelected, pcSelected]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",

          backgroundColor: stringToColor(pczoneSelected),
          gap: 10,
        }}
      >
        <div
          style={{
            width: "160px",
            minWidth: "160px",
            fontSize: 10,
            display: "flex",
            flexDirection: "row",
            flexWrap: "nowrap",
            marginLeft: 10,
          }}
        >
          {/* <div>{`🎮${DB_CafePC_ByCafe?.length}`}</div> */}
          {/* <Tooltip
            label={
              <>
                <ExampleSessionList data={DB_CafePC_ByCafe} />
              </>
            }
          >
            <div>🔍info</div>
          </Tooltip> */}
          <div>📌{pczoneSelected}</div>
        </div>
        <div
          style={{
            width: "70px",
            minWidth: "70px",
            fontSize: 15,
            textAlign: "right",
          }}
        >
          {/* <div>{pcSelected}</div> */}
          {/* <div>{cafeSelected}</div> */}
        </div>
        <div
          style={{
            display: "flex",
            gap: 0,
            width: "1400px",
            minWidth: "1400px",
          }}
        >
          {/* {DB_CafePC_ByCafe?.map((x, i) => {
            return <>{x.total_usage_sec}</>;
          })} */}

          {getDaysInMonth(dateSelected)?.map((x, i) => {
            return (
              <COMP_DailyUsage_ByZone
                key={i}
                _date_selected={`${dateSelected?.slice(0, 7)}-${x}`}
                // _date_selected_ori={dateSelected}
                _day_selected={x}
                _cafe={cafeSelected}
                _pc={pcSelected}
                _total_pc={total_pc}
                _zone={zone}
                _showMoreInfo={showMoreInfo}
              />
            );
          })}
          {/* {timeBlocks?.map((time, idx) => {
            const isGreen = isInRange(time);
            return (
              <div
                key={idx}
                style={{
                  width: 13, // narrower, since height will be more
                  height: 38, // taller to accommodate rotated text
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: isGreen ? "darkgreen" : "#eee",
                  color: isGreen ? "white" : "black",
                  borderRadius: 0,
                  fontSize: 10,
                  writingMode: "vertical-rl",
                  transform: "rotate(180deg)",
                  whiteSpace: "nowrap",
                  marginBottom: "0.1rem",
                }}
              >
                {time.format("HH:mm")}
              </div>
            );
          })} */}
        </div>
      </div>
    </>
  );
};

export default Chart_Bar_CafePOS_HeatMap_Daily_ByZone;
